import httpRequest from '@/utils/request'

// 分页查询
export function getList(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/noticesExt/page',
        method: 'post',
        data
    })
}

// 查询统计列表数量
export function pageCount(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/noticesExt/pageCount',
        method: 'post',
        data
    })
}

// 根据ID查询
export function getDB(id: any): Promise<any> {
    return httpRequest({
        url: `ext/noticesExt/${id}`,
        method: 'get'
    })
}

// 手动出入库使用 - 分页查询
export function findListPageForManual(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/appliancesExt/findListPageForManual',
        method: 'post',
        data
    })
}

// 根据仓库查询库存
export function choiceStockListPage(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wStockExt/choiceStockListPage',
        method: 'post',
        data
    })
}

// 根据仓库查询库存-标准版
export function choiceStockPageForStandard(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/choiceStockPageForStandard',
        method: 'post',
        data
    })
}

// 手动新建转库单
export function createZK(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wTransferExt/create',
        method: 'post',
        data
    })
}
